module.exports = __webpack_public_path__ + "static/img/61e63e793b6a179bddb257ad9179b38f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon4(4).png
// module id = vh5j
// module chunks = 1